import * as React from "react";
import BOPopover from "app/components/BOComponents/BOPopover";
import * as FontAwesome from "react-fontawesome";
import { createStyles, WithStyles, withStyles } from "@material-ui/core";

interface Props extends WithStyles<typeof styles> {
  comments: Array<string>;
  children: any;
}

type State = {
  popoverOpen: boolean;
  popoverEl: any;
};

const styles = createStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  popoverClickable: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  popupRoot: {
    padding: "15px",
  },
  comment: {
    fontSize: "16px",
    marginTop: "5px",
    marginBottom: "5px",
  },
});

const Comments = ({ comments, classes }) => {
  return (
    <div className={classes.popupRoot}>
      {comments?.map((comment, index) => {
        return (
          <div className={classes.comment} key={comments.length - index}>
            {comment}
          </div>
        );
      })}
    </div>
  );
};

class UserCommentsPopover extends React.Component<Props, State> {
  state = {
    popoverOpen: false,
    popoverEl: null,
  };

  setPopoverOptions = (event) => {
    event.preventDefault();

    this.setState({
      popoverOpen: true,
      popoverEl: event.currentTarget,
    });
  };

  closePopover = () => {
    this.setState({
      popoverOpen: false,
    });
  };

  render() {
    const { popoverOpen, popoverEl } = this.state;

    const displayData = (
      <>
        <Comments comments={this.props.comments} classes={this.props.classes} />
      </>
    );

    return (
      <BOPopover
        popover={displayData}
        externalOpen={{ open: popoverOpen, element: popoverEl }}
        externalClose={this.closePopover}
      >
        <div className={this.props.classes.root}>
          {this.props.children}
          <div
            className={this.props.classes.popoverClickable}
            onClick={this.setPopoverOptions}
          >
            <FontAwesome
              className="userCommentsPopoverIcon blue"
              name="sticky-note"
            />
            <span className="blue">More...</span>
          </div>
        </div>
      </BOPopover>
    );
  }
}

export default withStyles(styles)(UserCommentsPopover);
